import BrandSelect from './BrandSelect';

export default BrandSelect;
